import React from 'react';
import styled from 'styled-components';
import { getTeamLogoUrl } from '../utils/assetUrls';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
`;

const Logo = styled.img`
  width: ${(props) => props.$size ?? 24}px;
  height: ${(props) => props.$size ?? 24}px;
  object-fit: contain;
  flex-shrink: 0;
`;

/**
 * Renders a team name with optional logo when teamId is available.
 * @param {Object} props
 * @param {number|string} [props.teamId] - MLB team ID for logo
 * @param {string} props.teamName - Display name
 * @param {number} [props.size] - Logo size in px (default 24)
 * @param {boolean} [props.showName=true] - When false, only the logo is rendered
 */
function TeamWithLogo({ teamId, teamName, size = 24, showName = true }) {
  const logoUrl = getTeamLogoUrl(teamId);
  return (
    <Wrapper>
      {logoUrl && (
        <Logo
          src={logoUrl}
          alt=""
          $size={size}
          loading="lazy"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      )}
      {showName && <span>{teamName ?? '—'}</span>}
    </Wrapper>
  );
}

export default TeamWithLogo;
